const noUserNav = {
    type: 'link',
    value: 'Sign In',
    href: '/login',
    icon: 'person'
};

const userNav = {
    type: 'dropbar',
    value: 'Account',
    icon: 'person',
    dropBar: [
        {
            heading: 'Member',
            items: [
                { value: 'My Profile', href: '/players/0' },
                { value: 'My Availability', href: '/availability' },
                { value: 'Edit Profile', href: '/' },
                { value: 'Change Password', href: '/' },
                { value: 'Logout', href: '/logout' }
            ]
        },
        {
            heading: 'Captain',
            items: [
                { value: 'Team Selection', href: '/admin/selection' },
                { value: 'Add/Edit Results', href: '/admin/results' },
                { value: 'Personal Milstones', href: '/admin/milestones' }
            ]
        },
        {
            heading: 'Admin',
            items: [
                { value: 'Add Member', href: '/' },
                { value: 'Add/Edit News', href: '/admin/news' },
                { value: 'Add/Edit Fixtures', href: '/admin/fixtures' },
                { value: 'Add/Edit Events', href: '/admin/events' },
                { value: 'Add/Edit Club Websites', href: '/admin/clubs' }
            ]
        },
        {
            heading: 'Superuser',
            items: [
                { value: 'Members List', href: '/admin/members' },
                { value: 'Create Password', href: '/' },
                { value: 'View Permissions', href: '/admin/permissions' }
            ]
        }
    ]
};

const AccountStore = {
    getAccountNav(user) {
        if (user) {
            return userNav;
        }
        return noUserNav;
    }
};

export default AccountStore;



// WEBPACK FOOTER //
// ./src/stores/AccountStore.js